<h1 class="sr-only">Application Form</h1>
<main>
  <div class="root-container">
    <div class="overlay" *ngIf="isLoading || isDeterminationLoading || isReviewLoading || !dataCompleted"></div>
    <div class="d-flex flex-column align-items-center" *ngIf="isReviewLoading">
      <div class="spinner-border review-spinner" style="color:#2730E3; width: 3rem; height: 3rem; z-index: 1002;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="d-flex form-btns">
      <div class="d-grid gap-2" style="margin-left: 10px;">
        <eg-button *ngIf="currentFormIndex != 0"
          type="button"
          className="btn-primary-outline btn-color btn-font-family btn-icon"
          iconName="fa-less-than btn-icon"
          label="Back"
          [isDisabled]="false"
          (onClick)="onPrevious()"
        ></eg-button>
      </div>
      <div
        class="gap-2 d-md-flex justify-content-end"
        style="margin-inline-start: auto"
      >
        <eg-button *ngIf="currentFormIndex < reviewIndex && !isFormSubmitted"
            type="button"
            className="btn-primary-outline btn-color btn-font-family"
            label="Save Draft"
            [isDisabled]="isFormSubmitted ? true : false"
            (onClick)="onNext('saveDraft')"
        ></eg-button>
        <eg-button *ngIf="currentFormIndex < formLength - 1 && dataCompleted"
          type="button"
          className="btn-primary btn-font-family"
          iconClass="iconClass"
          [label]="saveButtonLabel"
          (onClick)="onNext()"
        ></eg-button>
        <eg-button *ngIf="currentFormIndex == formLength - 1 && !isFormSubmitted"
          type="button"
          className="btn-primary btn-font-family"
          iconClass="iconClass"
          [label]="saveButtonLabel"
          data-bs-toggle="modal" data-bs-target="#submitModal"
        ></eg-button>
        <eg-button *ngIf="currentFormIndex == formLength - 1 && isFormSubmitted"
          type="button"
          className="btn-primary btn-font-family"
          iconClass="iconClass"
          [label]="'Go To Profile'"
          (onClick)="gotoProfile()"
        ></eg-button>
      </div>
    </div>
    <section aria-label="Stepper and Forms">
      <ng-stepper
        #cdkStepper
        [linear]="true"
        style="pointer-events: none;"
        class="step"
      >
        <cdk-step *ngFor="let form of formData?.form?.subforms" [optional]="true">
          <ng-template cdkStepLabel>
            <div [attr.aria-label]="form.subform_name"class="progress-heading">{{ form.subform_name }}</div>
             
            <div class="step-bullet">
            </div>
          </ng-template>
            <section aria-label="Form Section">
            <div class="container" #stepOne style="pointer-events: all">
              <eg-form
                [subform_id]="form.subform_id"
                [subForm]="subForm"
                [stepIndex]="cdkStepper.selectedIndex"
                [dynFormGroup]="dynFormGroup"
                [formStyles]="formStyles"
                *ngIf="(!isLoading && currentFormIndex <= reviewIndex)"
              ></eg-form>
              <section aria-label="Feedback Section">
                <div class="container row justify-content-center form-layout" *ngIf="!isLoading && !isDeterminationLoading">
                  <div class="card mb-4 col-7 card-layout" [ngStyle]="formStyles" *ngIf="envMeckAgencyId && currentFormIndex == printIndex">
                    <div  class="card-body">
                      <label class="form-label">Print all eligibility pages</label>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"  [(ngModel)]="printOptionSelected" value="yes" disabled>
                        <label class="form-check-label" for="flexRadioDefault1">
                          Yes
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"  [(ngModel)]="printOptionSelected" value="no" checked disabled>
                        <label class="form-check-label" for="flexRadioDefault2">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-4 col-7 card-layout" *ngIf="envMeckAgencyId && currentFormIndex == printIndex && isFormSubmitted">
                    <div  class="card-body">
                      <label [for]="rating" class="form-label">Rating</label>
                      <input type="text" class="form-control" [(ngModel)]="rating" id="rating" disabled><br>
                      <label [for]="feedback" class="form-label">Feedback</label>
                      <textarea class="form-control" [(ngModel)]="feedback" id="feedback" disabled></textarea>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </section>
          <div class="d-flex">
            <div class="d-grid gap-2">
              <eg-button *ngIf="currentFormIndex != 0"
                  type="button"
                  className="btn-primary-outline btn-color btn-font-family btn-icon"
                  iconName="fa-less-than btn-icon"
                  label="Back"
                  style="pointer-events: all;"
                  [isDisabled]="false"
                  (onClick)="onPrevious()"
              ></eg-button>
            </div>
            <div
              class="gap-2 d-md-flex justify-content-end"
              style="margin-inline-start: auto"
            >
              <eg-button *ngIf="currentFormIndex < reviewIndex && !isFormSubmitted"
                  type="button"
                  className="btn-primary-outline btn-color btn-font-family"
                  label="Save Draft"
                  style="pointer-events: all;"
                  [isDisabled]="isFormSubmitted ? true : false"
                  (onClick)="onNext('saveDraft')"
              ></eg-button>
              <eg-button *ngIf="currentFormIndex < formLength - 1 && dataCompleted"
                type="button"
                className="btn-primary btn-font-family"
                iconClass="iconClass"
                [label]="saveButtonLabel"
                style="pointer-events: all;"
                (onClick)="onNext()"
              ></eg-button>
              <eg-button *ngIf="currentFormIndex == formLength - 1 && !isFormSubmitted"
                type="button"
                className="btn-primary btn-font-family"
                iconClass="iconClass"
                [label]="saveButtonLabel"
                style="pointer-events: all;"
                data-bs-toggle="modal" data-bs-target="#submitModal"
              ></eg-button>
              <eg-button *ngIf="currentFormIndex == formLength - 1 && isFormSubmitted"
                type="button"
                className="btn-primary btn-font-family"
                iconClass="iconClass"
                [label]="'Go To Profile'"
                style="pointer-events: all;"
                (onClick)="gotoProfile()"
              ></eg-button>
            </div>
          </div>
        </cdk-step>
      </ng-stepper>
    </section>

    <section aria-label="Submission Modal"> 
      <div class="modal" id="submitModal">
        <div class="modal-dialog">
          <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">Confirmation</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              Have you verified details and want to submit?
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-primary-outline modal-btn-1" data-bs-dismiss="modal" (click)="onSubmit('submit')">Yes</button>
              <button type="button" class="btn modal-btn" data-bs-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div class="d-flex flex-column align-items-center" *ngIf="isLoading || isDeterminationLoading">
    <div class="loading-text mb-3" style="color:#2730E3;font-size: 16px; font-weight: bold;z-index: 1000;" *ngIf="isDeterminationLoading && isEligibilityAutoDetermined">
      Determination letter is being generated, please wait...
    </div>
    
    <div class="spinner-border" style="color:#2730E3;width: 3rem; height: 3rem;z-index: 1000;" role="status" aria-label="Loading" *ngIf="((isLoading || isDeterminationLoading) && (!isReviewLoading))">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</main>
